module.exports = __webpack_public_path__ + "static/img/LxkyqbfwG.00b621b4.png";